export default function(smtp?: string, headers?: Headers) {
    if (!headers) {
        headers = new Headers();
    }
    if (smtp) {
        headers.set('X-OWA-ExplicitLogonUser', smtp);
        headers.set('X-AnchorMailbox', smtp);
    }
    return headers;
}
